import api from './axios'

const accessTokenLogin = obj => api('user/accessTokenLogin', 'POST', obj)

const editProfile = obj => api('editProfile', 'POST', obj)

const editVenueProfile = obj => api('editVenueProfile', 'POST', obj)

export default { accessTokenLogin, editProfile, editVenueProfile }
